import { displayCurrencyForLocale, normalizeLocale } from "@kupikupi/money";

export function miniDisplayLocale(language: string | undefined) {
  return normalizeLocale(language);
}

export function miniDisplayCurrency(language: string | undefined, currencies?: readonly string[]) {
  return displayCurrencyForLocale(miniDisplayLocale(language), currencies);
}
